import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getMentorForms } from "../dependencies/action";

// import LinearStepperCohort from "./LinearStepperCohort";
import CohortStartupForm from "./CohortStartupForm";

import { CssBaseline, Container, Paper, Box } from "@material-ui/core";

import {initGA, logPageView} from '../../../analytics'


const CohortStartupsForm = (props) => {
  
    useEffect(() => {
      // to call the initialise google analytics funtion
      try {
        initGA();
        window.GA_INITIALIZED = true;
        // to save the number og visitors on this side
        logPageView();
      } catch (error) {}
    }, [window]);
  
  const { getMentorForms, mentorFormList } = props;
  useEffect(() => {
    // getMentorForms();
  }, [getMentorForms]);

  return (
    <div
      // style={{ paddingTop: "70px" }}
      style={{
        // marginTop: "90px",
        // paddingTop: "25px",
        // backgroundColor:"#000",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundImage:
        "linear-gradient(119deg, #D2D8ED 0%, #EFF9FD 53%, #ffffff 100%)",
        // backgroundImage: `url(${formbg})`,
      }}
      className="mainformdivcohort"
    >
      <p className="form-heading-style-normal">MAARG Portal by Startup India</p>
      <h2 style={{ marginBottom: "-65px" }}>
        <p className="form-heading-style-bold">Cohort startup Program </p>
      </h2>
      <CssBaseline />
      <Container component={Box} p={4}>
        <Paper component={Box} p={3}>
          {/* <LinearStepperCohort /> */}
          <CohortStartupForm/>
        </Paper>
      </Container>
      <div className="formgraphicdiv"></div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //
  //
  return {
    // mentorFormList: state.GetMentorFormReducer.getMentorFormList,
  };
};
export default connect(mapStateToProps)(
  withRouter(CohortStartupsForm)
);

// export default MentorForm;
